<template>
    <div :class="classType" role="alert">
        {{message}}
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: {
        message: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'danger'
        }
    },
    computed: {
        classType() {
            return 'alert alert-' + this.type
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Message.vue